import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core";

type TruckIconProps = { altVersion?: boolean } & SvgIconProps;

function TruckIcon({ altVersion = false, ...others }: TruckIconProps) {
  return (
    <SvgIcon {...others} viewBox={altVersion ? "-12 0 47 16" : "-1 0 36 16"}>
      <g transform="translate(-5.174 -33.154)">
        <g transform="translate(5.174 33.154)">
          <path
            d="M74.766,61.544a1.74,1.74,0,1,0,1.739,1.74A1.741,1.741,0,0,0,74.766,61.544Zm0,2.42a.68.68,0,1,1,.681-.681A.682.682,0,0,1,74.766,63.964Z"
            transform="translate(-47.294 -50.777)"
          />
          <path
            d="M7.489,41.576H26.772c2.316,0,2.315-1.9,2.315-4.211s0-4.211-2.315-4.211H7.489c-2.316,0-2.315,1.9-2.315,4.211S5.172,41.576,7.489,41.576Z"
            transform="translate(-5.174 -33.154)"
          />
          <path
            d="M26.921,61.544a1.74,1.74,0,1,0,1.74,1.74A1.741,1.741,0,0,0,26.921,61.544Zm0,2.42a.68.68,0,1,1,.681-.681A.682.682,0,0,1,26.921,63.964Z"
            transform="translate(-17.594 -50.777)"
          />
          <path
            d="M14.458,61.544a1.74,1.74,0,1,0,1.739,1.74A1.741,1.741,0,0,0,14.458,61.544Zm0,2.42a.68.68,0,1,1,.681-.681A.681.681,0,0,1,14.458,63.964Z"
            transform="translate(-9.858 -50.777)"
          />
          <path
            d="M38.479,36.553a3.362,3.362,0,0,0-3.3-2.59H29.987v9.161H5.6v.98a1.887,1.887,0,0,0,1.62,2.064h.373c0-.048-.008-.1-.008-.146a2.453,2.453,0,0,1,4.818-.652,2.453,2.453,0,0,1,4.818.652c0,.049-.009.1-.011.146H30.231v-.006a2.679,2.679,0,0,1,5.358,0h2.4l1.447-3.093h0v-2.6ZM37.2,39.335a.619.619,0,0,1-.746.607l-2.873-.6a.615.615,0,0,1-.494-.608v-1.5a.622.622,0,0,1,.62-.62H36.58a.621.621,0,0,1,.619.62v2.094Z"
            transform="translate(-5.437 -33.656)"
          />

          {altVersion && (
            <>
              <rect width="6px" height="2px" x="-7px" style={{ borderRadius: "3px" }} y="3px" />
              <rect width="11px" height="2px" x="-12px" style={{ borderRadius: "3px" }} y="6px" />
              <rect width="10px" height="2px" x="-11px" style={{ borderRadius: "3px" }} y="9px" />
            </>
          )}
        </g>
      </g>
    </SvgIcon>
  );
}

export default TruckIcon;
